import PropTypes from 'prop-types'
import moment from 'moment'

import { displayWithCurrency } from '../../../../../utility/currency'
import AvatarStack from '../../../../common/avatar/AvatarStack'

import classes from './FamilyLeaderboardRow.module.scss'
import classnames from 'classnames'

const formatTenure = (joinedAt) => {
  if (!joinedAt) {
    return null
  }

  const months = moment()
    .diff(moment(joinedAt), 'months')

  if (months < 1) {
    return 'less than a month'
  }
  if (months < 12) {
    return `${months} month${months === 1 ? '' : 's'}`
  }

  const years = Math.floor(months / 12)
  return `${years} year${years === 1 ? '' : 's'}`
}

const FamilyLeaderboardRow = ({ rank, family, currency }) => {
  const tenure = formatTenure(family.joinedAt)

  return (
    <div className={classnames('mt-3 d-flex align-items-center', classes.leaderboardRow)}>
      <div className={classes.rank}>#{rank}</div>
      <div className={classnames('d-flex flex-column', classes.familyInfo)}>
        <span className={classes.name}>{family.name}</span>
        <span className={classes.subline}>
          {family.enrollmentsCount} enrollments{tenure ? ` · ${tenure}` : ''}
        </span>
      </div>
      <AvatarStack users={family.students} interactive={false} className={classes.avatarStack} />
      <div className={classnames('d-flex flex-column align-items-end', classes.revenue)}>
        <span>{displayWithCurrency(family.totalRevenue, currency, true)}</span>
        <span>Total Revenue</span>
      </div>
    </div>
  )
}

FamilyLeaderboardRow.propTypes = {
  rank: PropTypes.number.isRequired,
  family: PropTypes.shape({
    name: PropTypes.string,
    enrollmentsCount: PropTypes.number,
    joinedAt: PropTypes.string,
    totalRevenue: PropTypes.number,
    students: PropTypes.array,
  }).isRequired,
  currency: PropTypes.object,
}

export default FamilyLeaderboardRow
